var option_webview_default = {
  "option": "kMtME",
  "user_choice": "_4Lb8Y",
  "check": "I-GML",
  "image": "UVGdx",
  "input": "_95l3Z",
  "title": "t8DUT",
  "centered": "LNLU3",
  "with_result": "g-IaT",
  "list": "gsixH",
  "with_image": "_5hXVT",
  "progress": "ACdCK",
  "progress_value": "NclxQ",
  "label": "JkzOZ",
  "cta": "Z4uVS",
  "adornment_icon": "TbZKI",
  "remove": "C2Gpv",
  "removeButton": "SlmGv",
  "removeButtonIcon": "iS1hE",
  "overlay": "wn2Xi",
  "shown": "_8AUzi",
  "dark": "LV2hm",
  "spinner": "_8RVTf",
  "spin": "AQkWI",
  "grid": "kNcsT"
};
export {
  option_webview_default as default
};
//# sourceMappingURL=option-webview-scss.js.map
